import { useState } from "react";
import { Input } from "antd";
import profile from "../../../Assets/Icons/risk-profile-icon.svg";
import icon from "../../../Assets/Icons/allonge-security.svg";
import "./style.css";
import { useLocation } from "react-router-dom";
import MapContainerComponent from "../../../Components/MapContainer";

const ViewHighRiskActivityDetail = () => {
  const location = useLocation();
  const record = location.state;
  const [isDisabled, setIsDisabled] = useState(true);

  return (
    <div className="risk-form">
      <div className="view-high-risk">
        <div className="heading">{record.pageTitle ?? "High-Risk Activity"}</div>

        <div className="profile-details">
          <div className="image">
            <img
              src={
                record.customer.customer_profile_picture
                  ? `${process.env.REACT_APP_MEDIA_URL}${record.customer.customer_profile_picture}`
                  : profile
              }
              alt="Profile Icon"
              className="profile-image"
            />
          </div>
          <div className="info">
            <div className="name">{record.customer.customer_name}</div>
            <div className="email">{record.customer.email}</div>
          </div>
        </div>
        <hr className="divider" />

        <div className="company-info">
          <div className="heading">Recovery Company</div>
          <div className="sub-header">
            <div className="logo">
              <img src={icon} alt="icon" className="logo-icon" />
            </div>
            <div className="info">
              <div className="sub-info">{record.company.company_name}</div>
              <div className="sub-mail">{record.company.email_address}</div>
              <div className="sub-contact">
                {record.company.primary_contact_number}
              </div>
            </div>
          </div>
        </div>
        <hr className="divider" />

        <div className="form-items">
          <div className="input-group">
            <div className="title">Vehicle</div>
            <Input
              value={record.vehicle.vehicle_name}
              placeholder="Select Vehicle"
              disabled={isDisabled}
            />
          </div>

          <div className="input-group">
            <div className="title">Location</div>
            <Input
              value={
                record.location
                  ? `${record.location.latitude}, ${record.location.longitude}`
                  : "Location not available"
              }
              placeholder="Add Location"
              disabled={isDisabled}
            />
          </div>

          <div className="input-group">
            <div className="title">Status</div>
            <Input
              value={
                record.status.charAt(0).toUpperCase() + record.status.slice(1)
              }
              placeholder="Select Vehicle"
              disabled={isDisabled}
            />
          </div>

          <div className="input-group">
            <div className="title">Risk Score</div>
            <Input value={record.score.total_score} disabled={isDisabled} />
          </div>

          <div className="input-group">
            <div className="title">Reason </div>
            <Input value={record?.reason} disabled={isDisabled} />
          </div>
        </div>
      </div>
      <div className="map-wrapper">
        <div className="heat-map">
          <MapContainerComponent latitude={record.location.latitude} longitude={record.location.longitude} vehicle_name={record.vehicle.vehicle_name} />
        </div>
      </div>
      <div className="factors-table">
        <div className="table-header">
          <span className="header-factor">Factors</span>
          <span className="header-points">Points</span>
        </div>

        {Object.entries(record.score)
          .filter(([key]) => key !== "total_score" && key !== "updated_at")
          .map(([key, value], index) => (
            <div className="table-row" key={index}>
              <span className="factor">
                {key
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (c) => c.toUpperCase())}
              </span>
              <span className="points">{value}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ViewHighRiskActivityDetail;
